import { tableHeaderBg } from '@/styles/variants';
import { Table } from '@arco-design/web-react';
import styled from 'styled-components';

// 白底灰色边框盒子
export const GrayBorderBox = styled.div`
  border: 1px solid #dadada;
  border-radius: 4px;
  padding: 8px;
`;

// 灰色底色盒子
export const GrayBox = styled.div`
  background-color: #f5f5f5;
  padding: 8px;
`;
// 小标题
export const ItemTitle = styled.p`
  color: #000;
  opacity: 0.85;
  margin-bottom: 4px;
`;
// 灰色盒子内部的白色盒子
export const InsideWhiteBox = styled.div`
  background-color: #fff;
  padding: 8px;
  margin: 4px 0;
`;
// 盒子下面的描述
export const ItemDescription = styled.p`
  color: #000;
  opacity: 0.45;
  font-size: 12px;
`;

export const StyledTable = styled(Table)`
  /** 表头设置背景色 有地方的 !important 影响了,这里手动调整了 */
  .arco-table-container .arco-table-th {
    border-radius: 0;
    background-color: ${tableHeaderBg};
  }
  .arco-table-cell {
    color: #000;
    opacity: 0.85;
  }
`;
